import axios, { AxiosResponse } from 'axios';
import { encryptAndEncodeObject } from '../utils/crypto';

const instance = axios.create();

instance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => Promise.reject(error)
);

instance.interceptors.request.use((config) => {
  config.headers['x-api-key'] = encryptAndEncodeObject(process.env.REACT_APP_X_API_KEY);
  return config;
});

const request = (options: any) => {
  const onSuccess = (response: AxiosResponse) => response;
  const onError = (error: any) => Promise.reject(error.response || error.message);
  return instance(options).then(onSuccess).catch(onError);
};

export default request;
